import RoutesManager from '../../technical/routesManager';

const routesManager = new RoutesManager({baseUrl: window.location.origin});
export default routesManager;
